export default "__VITE_ASSET__DzI6eENY__"